signatureUrl<template>
  <div class="_content">
    <div class="content">
      <div class="agreement" id="agreementId" ref="agreementRef">
        <img  @click="showImagePreview(0)" :src="fileUrl1" />
        <img  @click="showImagePreview(1)" :src="fileUrl2" />
        <img  @click="showImagePreview(2)" :src="fileUrl3" />
        <img  @click="showImagePreview(3)" :src="assignSignUrl" ref="signImage" />
      </div>
      <div class="confirmBox">
        <div class="assignBox">
          <div class="assign-cont">
            <div class="assign-tip" v-if="signatureUrl">
              <div @click="isShowSignPad = true" class="reWrite">
                <img src="https://res.xiaokunkeji.cn/image/2025/11/24/6c46d1d2fa2f40f199b709185b80f9e7.png" />重绘
              </div>
              <img :src="signatureUrl" alt="" />
            </div>
            <div v-else class="assign-text" @click="isShowSignPad = true">
              <img src="https://res.xiaokunkeji.cn/image/2025/11/24/6c46d1d2fa2f40f199b709185b80f9e7.png" />手绘签名
            </div>
          </div>
          <p style="color:#808080; text-align: center; font-size: 0.6rem;">在手机屏幕上绘制本人真实姓名的个人签名</p>
        </div>
        <div class="assign-btn" :style="btnStyle" @click="submit">
          提交申请
        </div>
      </div>
    </div>

    <signPad :isShow="isShowSignPad" @close="close"></signPad>
  </div>
</template>

<script>
import { ImagePreview } from "vant"
import { Toast, Dialog, Loading } from 'vant'
import signPad from '../../components/signPad.vue'
import agreement from '../common/agreement.vue'
import config from '@/configs/config'
import SignPad from '../../components/signPad.vue'
import successImg from '@/imgs/image/success.png'
import util from '@/commons/util'
import { compressImage } from '@/commons/imageCompress'
import { findKey } from "lodash"
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
Vue.use(Loading)
export default {
  data() {
    return {
      shouldStorageShopForm: '0',
      assignSignPdfUrl: null, //pdf
      fileUrl1: 'https://res.xiaokunkeji.cn/image/2025/11/27/4a9c97f85a69488da988cb3ee22bbc44.jpg',
      fileUrl2: 'https://res.xiaokunkeji.cn/image/2025/11/27/330e4f9ac61a4088859b4bd1e8c5e62b.jpg',
      fileUrl3: 'https://res.xiaokunkeji.cn/image/2025/11/27/061bf0dd5f4d41c1bb57b8ad94da1fc9.jpg',
      fileUrl5: 'https://res.xiaokunkeji.cn/image/2025/11/27/4ba0fdd2433d47388cf7286c7da9331b.jpg',
      file1: null,
      file2: null,
      file3: null,
      file5: null,
      shopInfo: {},
      isAssign: true,
      assignSignUrlOrginal: 'https://res.xiaokunkeji.cn/image/2025/11/27/52a0c161d2e045b3b498c52043380c95.jpg',
      assignSignUrl: 'https://res.xiaokunkeji.cn/image/2025/11/27/52a0c161d2e045b3b498c52043380c95.jpg',
      assignSignUrl2: 'https://res.xiaokunkeji.cn/image/2025/11/27/52a0c161d2e045b3b498c52043380c95.jpg',
      form: {},
      signatureUrl: '',
      signatureUrl2: '',
      isShowSignPad: false,
      merchantCode: tuhu.getParam('merchantCode'),
      shopId: tuhu.getParam('shopId'),
      cryptoId: tuhu.getParam('cryptoId')
    }
  },
  components: {
    agreement,
    signPad
  },
  created() {},
  mounted() {
    util.getFile('https://res.xiaokunkeji.cn/image/2025/11/27/4a9c97f85a69488da988cb3ee22bbc44.jpg').then(file => {
      this.file1 = file
    })
    util
      .getFile('https://res.xiaokunkeji.cn/image/2025/11/27/330e4f9ac61a4088859b4bd1e8c5e62b.jpg')
      .then(file => (this.file2 = file))
    util
      .getFile('https://res.xiaokunkeji.cn/image/2025/11/27/061bf0dd5f4d41c1bb57b8ad94da1fc9.jpg')
      .then(file => (this.file3 = file))
    util
      .getFile('https://res.xiaokunkeji.cn/image/2025/11/27/4ba0fdd2433d47388cf7286c7da9331b.jpg')
      .then(file => (this.file5 = file))
    this.getAgreementInfo()
    // let vConsole = new VConsole()
  },

  computed: {
    btnStyle() {
      return {
        background: this.signatureUrl ? 'linear-gradient(355deg, #0061FE 0%, #42BEF5 100%)' : '#d8d8d8'
      }
    }
  },

  methods: {
    showImagePreview(key) {
        ImagePreview({
          images: [this.fileUrl1,this.fileUrl2,this.fileUrl3,this.assignSignUrl], // 要预览的图片数组（支持多张）
          closeable: true, // 显示关闭按钮
          closeOnPopstate: true, // 浏览器后退时关闭预览
          startPosition: key,
        });
    },
    async getAgreementInfo() {
      if (tuhu.getParam('cryptoId')) {
        let params = {
          shopId: tuhu.getParam('cryptoId')
        }
        let res = await tuhu.fetch(`${config.apis.GET_AGREEMERT_INFO}`, {
          method: 'post',
          body: JSON.stringify(params || '')
        })
        if (res.code === '200') {
          this.shopInfo = res.data.shopInfo
        } else {
          tuhu.toast(res.message || '网络错误')
        }
      } else {
        this.shouldStorageShopForm = tuhu.sessionStorage.getItem('shouldStorageShopForm')
        this.form = JSON.parse(tuhu.sessionStorage.getItem('shopForm'))
        console.log(this.form)
        this.shopInfo = {
          name: (this.form && this.form.shopName) || ''
        }
      }
    },
    close(url) {
      tuhu.showIndicator()
      this.isShowSignPad = false
      this.signatureUrl = url
      this.exportImage()
    },
    async submit() {
      if (!this.signatureUrl) return tuhu.toast('请滑动到页面下方签署姓名')
      if (!this.isAssign) return tuhu.toast('图片上传失败，需重新上传')
      if (!this.assignSignPdfUrl) return tuhu.toast('协议生成失败，请重新签字')
      // return
      let url = this.shouldStorageShopForm === '1' ? config.apis.SHOP_ADDSHOP : config.apis.ADD_AGREEMENT
      // !this.eventFlag ? url = config.apis.SHOP_ADDSHOP : url = config.apis.SHOP_EDITSHOP
      let form = this.shouldStorageShopForm === '1'
        ? Object.assign(this.form, {
            shopId: this.cryptoId || '',
            merchantCode: this.merchantCode || 'XKKJ',
            shopSignUrl: this.assignSignPdfUrl
          })
        : Object.assign({
            shopId: this.shopId,
            shopSignUrl: this.assignSignPdfUrl
          })
      try {
        const data = await tuhu.fetch(`${url}`, {
          method: 'post',
          body: JSON.stringify(form)
        })
        if (data && data.code === '200') {
          let msg = '提交成功，请耐心等待审核！'
          tuhu.sessionStorage.setItem('shopForm', null)
          tuhu.modal({
            title: '',
            text: `<img src="${successImg}" style="width:3.3rem; margin:0 auto">
                                    <div style="font-size:16px;font-weight:600;padding:.2rem 0">提交成功</div>
                                <div style="text-align:left">${msg}</div>`,
            buttons: [
              {
                text: '知道了',
                bold: true,
                onClick: () => {
                  if (this.form && this.form.shopName) {
                    setTimeout(() => {
                      tuhu.redirectTo({ url: '/pages/_login/index' })
                    }, 200)
                  } else {
                    setTimeout(() => {
                      tuhu.redirectTo({ url: '/pages/home/index' })
                    }, 200)
                  }
                }
              }
            ]
          })
        } else {
          tuhu.toast(data.message || '网络异常')
        }
      } catch (e) {}
    },
    async loadImages() {
      const loadImage = url =>
        new Promise((res, rej) => {
          const img = new Image()
          img.crossOrigin = 'Anonymous'
          img.onload = () => res(img)
          img.onerror = rej
          img.src = url
        })

      try {
        const [baseImg, overlayImg] = await Promise.all([loadImage(this.assignSignUrlOrginal), loadImage(this.signatureUrl)])
        this.assignSignUrl2 = baseImg
        this.signatureUrl2 = overlayImg
      } catch (error) {
        console.error('图片加载失败:', error)
      }
    },

    getFormattedDate() {
      const today = new Date()
      return `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`
    },

    drawWatermark(ctx, canvas, x, y, fillText) {
      const fontSize = Math.max(12, canvas.width * 0.015)
      ctx.font = `bold ${fontSize}px Arial`
      ctx.fillStyle = 'black'
      ctx.textAlign = 'left'

      const textX = canvas.width / x
      const textY = canvas.height * y

      ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'
      ctx.shadowBlur = 2
      ctx.fillText(fillText, textX, textY)
      ctx.shadowColor = 'transparent'
    },

    async exportImage() {
      await this.loadImages()
      if (!this.assignSignUrl2 || !this.signatureUrl2) {
        alert('请先加载图片')
        return
      }
      const exportCanvas = document.createElement('canvas')
      const exportCtx = exportCanvas.getContext('2d')

      // 设置导出尺寸为背景图原始尺寸
      exportCanvas.width = this.assignSignUrl2.width
      exportCanvas.height = this.assignSignUrl2.height

      // 绘制背景图
      exportCtx.drawImage(this.assignSignUrl2, 0, 0)

      // 计算叠加图位置和尺寸
      const overlayHeight = Math.max(12, exportCanvas.width * 0.04) // 固定高度（单位px）
      const overlayWidth = (overlayHeight * this.signatureUrl2.width) / this.signatureUrl2.height
      const posX = this.assignSignUrl2.width * 0.28 - overlayWidth / 2
      const posY = this.assignSignUrl2.height * 0.333 - overlayHeight / 2
      8
      // 绘制叠加图
      exportCtx.drawImage(this.signatureUrl2, posX, posY, overlayWidth, overlayHeight)

      this.drawWatermark(exportCtx, exportCanvas, 5, 0.317, this.shopInfo.name || '')
      const time = this.getFormattedDate()
      // 添加动态水印
      this.drawWatermark(exportCtx, exportCanvas, 5, 0.357, time || '')
      this.drawWatermark(exportCtx, exportCanvas, 1.55, 0.357, time || '')
      // 导出图片
      const base64ImgtoFile = (dataurl, filename = 'file') => {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {
          type: mime
        })
      }
      const _signImg = exportCanvas.toDataURL('image/png')
      let imgFile = base64ImgtoFile(_signImg)
      // 上传前先压缩：等比缩放到最大边长后重新编码（压缩失败或体积未变小时返回原文件）
      imgFile = await compressImage(imgFile)
      if (!imgFile) {
        // 处理超时已提示"处理失败"，终止本次上传
        tuhu.hideIndicator()
        return
      }
      const mess = new FormData()
      mess.append('multipartFile', imgFile)
      await tuhu
        .fetch(`${config.apis.UPLOAD_URL}`, {
          method: 'post',
          body: mess
        })
        .then(async res => {
          if (res.code === '200') {
            this.assignSignUrl = res.data
            await this.getPdf(imgFile)
            this.isAssign = true
            // this.$nextTick(() => {
            //   this.handleScroll()
            // })
          } else {
            this.isAssign = false
            tuhu.hideIndicator()
            tuhu.toast(res.message || '网络错误')
          }
        })
      // const link = document.createElement('a')
      // link.href = exportCanvas.toDataURL('image/png')
      // link.download = `合成图片_${this.getFormattedDate()}.png`
      // link.click()
    },

    async imgBase64ToUrl(data) {
      // 原有上传逻辑保持不变
      const params = { baseFile: data, fileName: '签名.png' }
      try {
        const res = await tuhu.fetch(config.apis.UploadBase64File, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(params)
        })

        if (res.code === '200') {
          this.assignSignUrl = res.data
        } else {
          tuhu.toast(res.message || '上传失败')
        }
      } catch (err) {
        console.error('上传错误', err)
        tuhu.toast('请求异常')
      } finally {
      }
    },
    async getPdf(imgFile) {
      const files = [this.file1, this.file2, this.file3, imgFile, this.file5]
      const mess = new FormData()
      files.forEach(file => {
        mess.append('multipartFile', file)
      })

      await tuhu
        .fetch(`${config.apis.UPLOAD_URL_TO_PDF}`, {
          method: 'post',
          body: mess
        })
        .then(res => {
          if (res.code === '200') {
            this.assignSignPdfUrl = res.data
          } else {
            tuhu.toast(res.message || '网络错误')
          }
        })
        tuhu.hideIndicator()
    },

  }
}
</script>
<style lang="less" scoped>
@media screen and (orientation: landscape) {
  /*横屏 css*/
  ._content {
    overflow: auto;
    .content {
      overflow: auto;
    }
  }
}
._content {
  display: flex;
  flex-direction: column;
  align-items: center;
  .content {
    .agreement {
      position: relative;
      width: calc(100vw - 1.5rem);
      min-height: calc(100vh - 30.45rem);
      max-height: calc(100vh - 13.45rem);
      height: auto;
      background: #fff;
      overflow-y: scroll;
      border-radius: 0.4rem;
      margin: 0.6rem 0.75rem;
      padding: 0.75rem 0.5rem;
      .bottomStyle {
        position: absolute;
        top: calc(100vh - 30.45rem);
      }
    }
    .confirmBox {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: calc(100vw - 1.5rem);
      height: 11.45rem;
      margin: 0.6rem 0.75rem 0;
      bottom: 0;
      .assignBox {
        width: calc(100vw - 1.5rem);
        height: 8.25rem;
        background: #ffffff;
        box-shadow: 0rem 0.05rem 0.48rem 0rem rgba(185, 185, 185, 0.02);
        border-radius: 0.5rem;
        margin-bottom: 1rem;
        .assign-cont {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0.6rem;
          width: calc(100vw - 2.5rem);
          height: 5.9rem;
          border-radius: 0.1rem;
          border: 0.03rem dotted #a6adb9;
          .assign-tip {
            position: relative;
            width: 16.05rem;
            height: 5.9rem;
            .reWrite {
              display: flex;
              flex-wrap: nowrap;
              position: fixed;
              width: 2.5rem;
              height: 1.2rem;
              position: absolute;
              top: 0;
              right: 0;
              img {
                width: 0.9rem;
                height: 0.9rem;
              }
            }
          }
        }
        .assign-text {
          width: 5.85rem;
          height: 1.8rem;
          border-radius: 1.1rem;
          border: 0.03rem solid #4b6af7;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 500;
          font-size: 0.7rem;
          color: #4b6af7;
          line-height: 0.7rem;
          img {
            width: 0.9rem;
            height: 0.9rem;
            margin-right: 0.3rem;
          }
        }
      }
    }
    .assign-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 17.25rem;
      height: 2.2rem;
      background: #d8d8d8;
      border-radius: 1.1rem;
      font-weight: 500;
      font-size: 0.75rem;
      color: #ffffff;
      line-height: 0.75rem;
      margin-bottom: 0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/assignMent/index.vue